(function () {
var $d1cd183193b6fe50$var$sectionTracker = {
    init: function() {
        this.appendTrackerItems();
    },
    setIdSlugToHeadingFromTitle: function(heading) {
        var title = heading.innerText;
        var slug = title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
        heading.id = slug;
    },
    appendTrackerItems: function() {
        var heading_level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
        var sectionTrackerWrapper = document.querySelector('.section-tracker');
        if (!sectionTrackerWrapper) return;
        var sectionTrackerElement = sectionTrackerWrapper.querySelector('.section-tracker__list');
        var sections = document.querySelectorAll(".section-tracker-wrapper h".concat(heading_level, ".wp-block-heading"));
        if (sections.length === 0) {
            $d1cd183193b6fe50$var$sectionTracker.hideEmptyContainer(sectionTrackerWrapper);
            return;
        }
        var trackerItems = [];
        sections.forEach(function(item) {
            var sectionID = item.id;
            if (!sectionID) $d1cd183193b6fe50$var$sectionTracker.setIdSlugToHeadingFromTitle(item);
            sectionID = item.id;
            var sectionTitle = item.innerText;
            var sectionItem = $d1cd183193b6fe50$var$sectionTracker.createNavigationItem(sectionID, sectionTitle);
            trackerItems.push(sectionItem);
        });
        $d1cd183193b6fe50$var$sectionTracker.addItemsToContainerList(trackerItems);
    },
    createNavigationItem: function(ID, title) {
        var listItem = document.createElement('li');
        var navigationItem = document.createElement('a');
        navigationItem.href = "#".concat(ID);
        navigationItem.innerText = title;
        listItem.append(navigationItem);
        return listItem;
    },
    addItemsToContainerList: function(items) {
        var sectionTrackerElement = document.querySelector('.section-tracker__list');
        if (!sectionTrackerElement) return;
        items.forEach(function(item) {
            sectionTrackerElement.append(item);
        });
    },
    hideEmptyContainer: function(parentElement) {
        if (!parentElement) return;
        parentElement.style.display = 'none';
    }
};
var $d1cd183193b6fe50$export$2e2bcd8739ae039 = $d1cd183193b6fe50$var$sectionTracker;
$d1cd183193b6fe50$var$sectionTracker.init();

})();
//# sourceMappingURL=script.js.map
